var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaintOption32 = function SvgPaintOption32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.275 2.009h3.462c.866 0 1.696.358 2.307.995A3.47 3.47 0 0 1 12 5.407v19.385a5.32 5.32 0 0 1-1.464 3.683A4.901 4.901 0 0 1 7 30a4.901 4.901 0 0 1-3.536-1.525A5.32 5.32 0 0 1 2 24.792V5.394c0-.9.343-1.764.954-2.4A3.194 3.194 0 0 1 5.258 2l.017.009Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12 11.75 3.85-4.57a3.118 3.118 0 0 1 2.12-1.165 3.083 3.083 0 0 1 2.3.719l2.58 2.18a3.263 3.263 0 0 1 1.135 2.18 3.3 3.3 0 0 1-.696 2.37l-9.582 12.035-.804 1.005L11 29",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m21.302 15.54 3.779-.454a3.28 3.28 0 0 1 2.549.455 3.509 3.509 0 0 1 1.495 2.19l.79 3.631a3.63 3.63 0 0 1-.435 2.647 3.45 3.45 0 0 1-.908.993 3.317 3.317 0 0 1-1.206.556L7 30M3 8h9m-9 5h9m-9 5h9",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 26a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
    fill: "currentColor"
  })));
};
export default SvgPaintOption32;